module.exports = {
	"name": "client",
	"version": "1.16.0",
	"private": true,
	"devDependencies": {
		"babel-eslint": "^7.2.3",
		"react-scripts": "0.9.5"
	},
	"dependencies": {
		"@material-ui/core": "^4.11.0",
		"@material-ui/icons": "^4.9.1",
		"axios": "^0.19.2",
		"bootstrap": "^4.5.2",
		"create-react-class": "^15.6.3",
		"date-fns": "^2.16.1",
		"eventing-bus": "^1.3.3",
		"font-awesome": "^4.7.0",
		"formik": "^2.1.4",
		"jquery": "^3.5.1",
		"js-file-download": "^0.4.1",
		"keymirror": "^0.1.1",
		"moment": "^2.22.2",
		"numeral": "^2.0.6",
		"pdfmake": "^0.1.68",
		"prop-types": "^15.7.2",
		"query": "^0.2.0",
		"randomstring": "^1.1.5",
		"react": "^16.13.1",
		"react-16-bootstrap-date-picker": "^5.1.2",
		"react-async-script": "^0.9.1",
		"react-block-ui": "^0.2.6",
		"react-bootstrap": "^0.32.4",
		"react-bootstrap-form": "^0.1.4-beta6",
		"react-bootstrap-table": "^4.3.1",
		"react-dom": "^16.13.1",
		"react-google-recaptcha": "^0.9.9",
		"react-hook-use-state": "^1.1.0",
		"react-localization": "^0.1.1",
		"react-redux": "^7.2.0",
		"react-router-bootstrap": "^0.24.2",
		"react-router-dom": "^4.3.1",
		"react-scrollable-anchor": "^0.4.2",
		"react-select": "^2.0.0",
		"redux": "^4.0.5",
		"yup": "^0.29.3"
	},
	"scripts": {
		"analyze": "source-map-explorer build/static/js/main.*",
		"start": "REACT_APP_API_AGD='http://localhost:8090/api/' react-scripts start",
		"start-prod": "REACT_APP_API_AGD='https://api.agd-online.com/' react-scripts start",
		"build": "react-scripts build",
		"test": "react-scripts test --env=jsdom",
		"eject": "react-scripts eject"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 1320
// module chunks = 0